var _rect, _path, _circle, _line, _line2, _line3, _line4, _line5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataControl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 32,
    width: 40,
    height: 26,
    rx: 5,
    fill: "none",
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 32V26C28 21.6 33.4 18 40 18C46.6 18 52 21.6 52 26V32",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 45,
    r: 4,
    fill: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 49,
    x2: 40,
    y2: 53,
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 40,
    x2: 20,
    y2: 40,
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    opacity: 0.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 48,
    x2: 20,
    y2: 48,
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    opacity: 0.3
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 40,
    x2: 66,
    y2: 40,
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    opacity: 0.5
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 48,
    x2: 66,
    y2: 48,
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    opacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataControl);
export default __webpack_public_path__ + "static/media/DataControl.f7a2c2081917e91f2c91bfd5ae381ef1.svg";
export { ForwardRef as ReactComponent };